import styled from 'styled-components'

import { Carousel, FlexContainer } from '@/components'

export const FlexContainerAdaptedProccess = styled(FlexContainer)`
  max-width: 100%;
  width: 100%;
  flex-direction: column;
  gap: 112px;

  @media (max-width: 1180px) {
    padding: 0 16px !important;
  }
`
export const AdaptedProcessesContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  max-width: 1170px;

  align-items: flex-start;
  gap: 24px;

  .topics {
    display: grid;
    grid-template-columns: repeat(2, minmax(300px, 569px));
    width: 100%;
    margin-top: 64px;
    gap: 32px;
    .topic {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 100%;
      gap: 8px;
      background: linear-gradient(
        180deg,
        rgba(8, 237, 220, 0.1) 0%,
        rgba(8, 237, 220, 0.15) 50%,
        rgba(8, 237, 220, 0.1) 100%
      );
      box-shadow: 0px 0px 18px rgba(8, 237, 220, 0.1);
      border-radius: 32px;
      padding: 24px;
      transition: transform 0.3s ease-in-out;

      .topic-group {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 8px;
      }

      &:hover {
        transform: scale(1.05);
      }
    }
  }

  @media (max-width: 1180px) {
    .topics {
      justify-content: center;
    }
  }
  @media (max-width: 791px) {
    .topics {
      margin-top: 40px;
      grid-template-columns: repeat(auto-fill, minmax(200px, 100%));
      .topic .topic-group {
        padding: 8px;
      }
    }
  }
`

export const TechnologiesContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  overflow-y: hidden;
  overflow-x: auto;
  justify-content: center;
  position: relative;

  @media (min-width: 2000px) {
    max-width: 1800px;
  }

  &::before,
  &::after {
    content: ' ';
    position: absolute;
    z-index: 9;
    width: 180px;
    height: 100%;
  }
  &::before {
    top: 0;
    left: 0;
    background: linear-gradient(
      to right,
      rgba(7, 8, 19, 1) 0%,
      rgba(7, 8, 19, 0) 100%
    );
  }
  &::after {
    top: 0;
    right: 0;
    background: linear-gradient(
      to left,
      rgba(7, 8, 19, 1) 0%,
      rgba(7, 8, 19, 0) 100%
    );
  }
`

export const Slider = styled(Carousel)``
